import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import Header from "../common/header/Header";
import { Toast } from "../common/toast/toast";
import { BackButton } from "../common/back-button/back-button";
import MultiSelectWithCheckboxEdit from "./multiselect-locations-edit";
import { CloseIcon } from "../../assets/icons/close-icon-simple";
import SecondaryButton from "../common/buttons/SecondaryButton";

const EditRecruiters = ({ id, addToast, closeRecruierSidebar }) => {
  const location = useLocation();
  const [addfirstName, setAddfirstName] = useState("");
  const [addlastName, setAddlastName] = useState("");
  const [addrecruiterEmail, setAddrecruiterEmail] = useState("");
  const [addrecruiterClinicId, setAddrecruiterClinicId] = useState("");
  const [recruiterById, setRecruiterById] = useState([]);
  const [toasts, setToasts] = useState([]);
  const [apiLoader, setApiLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [isEditRecruiter, setIsEditRecruiter] = useState(true);

  const fetchData = async () => {
    const response = await axios
      .get(`${ENDPOINTS.RECRUITERS.RECRUITER_BY_ID}?recruiterID=${id}`)
      .then((res) => {
        setRecruiterById(res.data.data);
        setAddfirstName(res.data.data.firstName);
        setAddlastName(res.data.data.lastName);
        setAddrecruiterEmail(res.data.data.recruiterEmail);
        const fetchRecId = res.data.data.clinicalRecruiterData;
        const recruiterByIdAre = fetchRecId.map((i) => i.clinicalInfoID);
        setAddrecruiterClinicId(recruiterByIdAre);
      });
  };

  const [clinicInfoId, setclinicInfoId] = useState([]);

  const fetchClinicData = async () => {
    await axios.get(ENDPOINTS.CLINIC.CLINIC_INFO).then((res) => {
      const response = JSON.stringify(res.data.data);
      console.log("response", response);
      setclinicInfoId(JSON.parse(response));
      //console.log('clinicInfoId => ', res.data.data);
    });
  };
  useEffect(() => {
    fetchData();
    fetchClinicData();
  }, []);

  // to get clinicinfo id

  const [selectedClinicId, setSelectedClinicId] = useState([]);
  useEffect(() => {
    setSelectedClinicId([...addrecruiterClinicId]);
  }, [addrecruiterClinicId]);
  const recruiterOptions = clinicInfoId.map((clinic) => ({
    value: clinic.name,
    label: clinic.name,
    id: clinic.clinicalInfoID, // Custom property to store ID
  }));

  // Handle location selection
  const handleSelectChange = ({ selectedIds }) => {
    console.log("Selected Recruiter IDs:", selectedIds);
    setSelectedClinicId(selectedIds); // Update selected recruiter clinic IDs
  };

  const editSelectedIds = [addrecruiterClinicId];

  console.log("editSelectedIds => ", addrecruiterClinicId);

  const [popup, setPopup] = useState({
    show: false,
    message: "",
    isError: false,
  });
  const closePopup = () => {
    setPopup({ show: false, message: "", isError: false });
  };

  const validateFields = () => {
    const newErrors = {};

    if (!addfirstName.trim())
      newErrors.addfirstName = "First name is required.";
    if (!addlastName.trim()) newErrors.addlastName = "Last name is required.";
    if (!addrecruiterClinicId)
      newErrors.addrecruiterClinicId = "Clinic is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditClinic = async (e) => {
    setApiLoader(true);
    e.preventDefault();
    console.log("selectedClinicId selectedClinicId => ", selectedClinicId);
    console.log(
      "selectedClinicId recruiterById.clinicalInfoID",
      recruiterById.clinicalInfoID
    );
    console.log("selectedClinicId addrecruiterClinicId", addrecruiterClinicId);
    const ResponseBody = {
      recruiterID: id,
      firstName: addfirstName,
      lastName: addlastName,
      recruiterEmail: addrecruiterEmail,
      clinicalInfoIDs: selectedClinicId,
    };
    try {
      const response = await axios.put(
        ENDPOINTS.RECRUITERS.EDIT_RECRUITERS,
        ResponseBody
      );
      setApiLoader(false);
      // setPopup({ show: true, message: "The recruiter details has been updated successfully!", isError: false });
      addToast("Recruiter has been updated successfully.", "success");
      closeRecruierSidebar();
    } catch (error) {
      // console.error("Error updating data:", error);
      // setPopup({ show: true, message: error, isError: true });
      setApiLoader(false);
      addToast("Failed to update the recruiter.", "error");
    }
  };

  return (
    <>
      <div className="text-center w-[570px]  bg-white h-full">
        <div
          className="border-b border-[#B2ACC9] w-full"
          style={{ borderColor: "rgb(200, 214, 230)" }}
        >
          <div className="flex justify-between items-center w-full px-5 py-6">
            <h2 className="font-semibold text-left">Edit Recruiter</h2>
            <button
              onClick={() => {
                closeRecruierSidebar();
              }}
            >
              <CloseIcon />{" "}
            </button>
          </div>
        </div>
        <div className="flex flex-col h-[calc(100vh-150px)] py-8">
          <div className="p-8 pb-0 pt-0 overflow-y-auto h-[calc(100vh-370px)] text-left ">
            <div>
              <div className="w-full grid gap-4">
                <div>
                  <label
                    for="clinicName"
                    class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
                  >
                    First Name <span className="aestrick_color">*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                    required
                    defaultValue={addfirstName}
                    disabled={isEditRecruiter}
                    onChange={(e) => setAddfirstName(e.target.value)}
                  />
                  {errors.addfirstName && (
                    <p className="text-red-600">{errors.addfirstName}</p>
                  )}
                </div>
                <div>
                  <label
                    for="lastname"
                    class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
                  >
                    Last Name <span className="aestrick_color">*</span>
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                    required
                    disabled={isEditRecruiter}
                    defaultValue={recruiterById.lastName}
                    onChange={(e) => setAddlastName(e.target.value)}
                  />
                  {errors.addlastName && (
                    <p className="text-red-600">{errors.addlastName}</p>
                  )}
                </div>
                <div>
                  <label
                    for="recruiterEmail"
                    class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
                  >
                    Email Id <span className="aestrick_color">*</span>
                  </label>
                  <input
                    type="text"
                    name="recruiterEmail"
                    className="field_bg border_color border text-sm rounded-lg block w-full p-2.5 h-12 cursor-not-allowed"
                    required
                    defaultValue={recruiterById.recruiterEmail}
                    disabled
                  />
                  {errors.addrecruiterEmail && (
                    <p className="text-red-600">{errors.addrecruiterEmail}</p>
                  )}
                </div>
                <div>
                  <label
                    for="clinicName"
                    class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
                  >
                    Location <span className="aestrick_color">*</span>
                  </label>
                  <div
                    className="border_color border text-sm rounded-lg block w-full p-1 appearance-none"
                    style={{ minHeight: "3rem" }}
                  >
                    {recruiterOptions && (
                      <MultiSelectWithCheckboxEdit
                        options={recruiterOptions}
                        selectedValues={selectedClinicId}
                        onChange={handleSelectChange}
                        isDisabled={isEditRecruiter}
                      />
                    )}
                    {errors.addrecruiterClinicId && (
                      <p className="text-red-600">
                        {errors.addrecruiterClinicId}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 pl-[36px] bottom-0 w-full -ml-8 bg-white pl-8 flex gap-[20px]">
                <button
                  type="submit"
                  className="btn-primary-base-bar primary_btn"
                  disabled={apiLoader}
                  onClick={
                    isEditRecruiter
                      ? ()=>setIsEditRecruiter(false)
                      : handleEditClinic
                  }
                >
                  {apiLoader ? (
                    <div className="flex justify-center">
                      <div className="mini-spinner "></div>
                    </div>
                  ) : isEditRecruiter ? (
                    "Edit"
                  ) : (
                    "Update"
                  )}
                </button>
                <SecondaryButton
                  onClick={() => closeRecruierSidebar()}
                  label="Cancel"
                  className="text-[#1A1A1B!important] hover:text-[#ffffff!important]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRecruiters;
